import { StandingAccessReportProgressAppModel } from '@api';
import { LinearProgress, Stack, styled, Typography } from '@mui/material';

interface AssessmentProgressProps {
  progress: StandingAccessReportProgressAppModel;
  message?: string;
}

const DEFAULT_MESSAGE = 'We will notify you when the assessment is ready';

const ProgressWrapper = styled(Stack)({
  width: '100%',
});

export default function AssessmentProgress({ progress, message = DEFAULT_MESSAGE }: AssessmentProgressProps) {
  const progressPercentage = Math.round((progress.step / progress.total_steps) * 100);

  return (
    <Stack direction="column" alignItems="flex-start" spacing={0} width="100%">
      <Typography variant="helperText" color="text.muted" role="status">
        {message}
      </Typography>
      <ProgressWrapper direction="row" spacing={1} alignItems="center">
        <LinearProgress
          variant="determinate"
          value={progressPercentage}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={progressPercentage}
          sx={{ flexGrow: 1 }}
        />
        <Typography variant="body2" color="text.secondary" sx={{ minWidth: 35 }}>
          {progressPercentage}%
        </Typography>
      </ProgressWrapper>
    </Stack>
  );
}
